import danish from '../../resources/da.json';
import english from '../../resources/en.json';
import french from '../../resources/fr.json';
import hungarian from '../../resources/hu.json';
import serbian from '../../resources/sr.json';
import slovak from '../../resources/sk.json';
import ukranian from '../../resources/uk.json';
import { createIntl, createIntlCache, IntlShape } from 'react-intl';

enum Languages {
  EN = 'en-us',
  DA = 'da-dk',
  UA = 'uk-ua',
  SR = 'sr-rs',
  HU = 'hu-hu',
  SK = 'sk-sk',
  FR = 'fr-fr',
}

const loadLocaleData = (locale: string): Record<string, string> => {
  switch (locale) {
    case Languages.DA:
      return danish;
    case Languages.UA:
      return ukranian;
    case Languages.SR:
      return serbian;
    case Languages.HU:
      return hungarian;
    case Languages.SK:
      return slovak;
    case Languages.FR:
      return french;
    case Languages.EN:
      return english;
    default:
      return english;
  }
};

/* Creates a translation service for given culture code. */
export function createTranslationService(cultureCode: string): IntlShape {
  const lowerCasedCultureCode: string = cultureCode.toLowerCase();
  const cache = createIntlCache();
  const messages =
    cultureCode === Languages.EN
      ? loadLocaleData(Languages.EN)
      : Object.assign({}, loadLocaleData(Languages.EN), loadLocaleData(lowerCasedCultureCode));
  const staticIntl = createIntl(
    {
      locale: lowerCasedCultureCode,
      defaultLocale: Languages.EN,
      messages,
    },
    cache
  );

  return staticIntl;
}
